<template>
  <div class="div-ad-content">
    <Rule class="iframe-content" @clickRule="backShow" v-show="showRule" />
    <img class="img-ad-bg" src="@/assets/imgs/voucher/img_voucher_bg.png" v-show="!showRule">
    <div class="div-ad-title" v-show="!showRule">
      <img class="img-ad-title" src="@/assets/imgs/voucher/icon_voucher_corner.png">
      <span class="span-ad-title" @click="showRule = true">活动规则》</span>
    </div>
    <div class="div-ad-tips" v-show="!showRule">
      <img class="img-ad-tips" src="@/assets/imgs/voucher/icon_voucher_content_corner.png">
      <span class="span-ad-tips">上传消费凭证送1期免息券</span>
      <span class="span-ad-tips">消费凭证审核合格再送3期免息券</span>
      <div class="btn-ad-join" @click="join">我要参加</div>
    </div>
    <div class="div-ad-bottom" v-show="!showRule">客服热线：4008769898  客服工作时间：工作日9:00-12:00 13:30-18:00</div>
  </div>
</template>
<script>
import Rule from "@/views/ConsumerVoucher/rule/Rule.vue";

export default {
  components: {
    Rule
  },

  data() {
    return {
      showRule: false,
    }
  },

  methods: {
    join() {
      this.$emit('clickSplash');
    },

    backShow() {
      this.showRule = false;
    }
  },
}
</script>

<style lang='less' scoped>
@import './splash.less';
</style>